import React from 'react'
import WhatWeDo from '../../components/home/WhatWeDo'
import HowItWorks from '../../components/home/HowItWorks'
import Benifits from '../../components/dao/Benifits'
import LaunchACampaign from '../../components/impact-campaigns/launch_a_campaign'
import Meta from '../../components/Meta'

export default function ImpactCampaigns() {
  return (
   <main>
    <Meta title=" Impact Campaigns || Impactoverse"></Meta>
    <WhatWeDo />
    <HowItWorks />
  <LaunchACampaign title={"Launch a Campaign"}/>
   </main>
  )
}
